module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-30-fa6e425b161a60604ff453b83035b8d8.svg";